<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Ranking de insignias</span>
</mat-toolbar>

<div class="group-bar">
  <div class="group-bar-scroll">
    <button
      type="button"
      class="group-chip"
      [class.active]="groupSelected === 'general'"
      (click)="selectGroup('general')"
    >
      🌍 General
    </button>
    @for (group of groups; track group) {
      <button
        type="button"
        class="group-chip"
        [class.active]="groupSelected === group._id"
        (click)="selectGroup(group._id)"
      >
        {{ group.name }}
      </button>
    }
  </div>
</div>

<div class="stats-badges-page">
  @for (entry of badgesRanking; track entry.user._id; let i = $index) {
    <button
      type="button"
      class="badge-card"
      [class.is-me]="entry.user._id === loggedUser?._id"
      (click)="openBadgeBook(entry)"
    >
      <div class="badge-rank">{{ i + 1 }}</div>
      <app-avatar [user]="entry.user"></app-avatar>
      <div class="badge-copy">
        <div class="badge-name">{{ entry.user.name }}</div>
        <div class="badge-medals">
          <span>🥇 {{ entry.gold }}</span>
          <span>🥈 {{ entry.silver }}</span>
          <span>🥉 {{ entry.bronze }}</span>
        </div>
      </div>
      <div class="badge-total">{{ entry.total }}</div>
    </button>
  }
</div>
